"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var renderTableHeading = function renderTableHeading(headings, props) {
  // eslint-disable-next-line
  var t = props.t;
  return /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: 'table-heading'
  }, headings.map(function (heading) {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: heading.className,
      className: heading.className
    }, t(heading.label));
  })));
}; // eslint-disable-next-line react/display-name


var renderTableBody = function renderTableBody(headings, props) {
  return function (rows) {
    // eslint-disable-next-line
    var t = props.t;
    return /*#__PURE__*/_react.default.createElement("tbody", null, rows.map(function (row, index) {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: index,
        className: 'table-row'
      }, headings.map(function (heading) {
        var additionalClasses = [];

        if (row[heading.checkIsTitle]) {
          additionalClasses.push('header');

          if (row[heading.key] === '') {
            additionalClasses.push('disabled');
          }
        }

        return /*#__PURE__*/_react.default.createElement("td", {
          key: t(heading.key),
          className: "".concat(heading.className, " ").concat(additionalClasses.join(' '))
        }, !heading.ignoreInnerHeading && /*#__PURE__*/_react.default.createElement("span", {
          className: 'inner-heading'
        }, t(heading.label)), /*#__PURE__*/_react.default.createElement("span", {
          className: 'table-value'
        }, t(row[heading.key])));
      }));
    }));
  };
};

var OutputTable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(OutputTable, _React$PureComponent);

  function OutputTable(props) {
    _classCallCheck(this, OutputTable);

    return _possibleConstructorReturn(this, (OutputTable.__proto__ || Object.getPrototypeOf(OutputTable)).call(this, props));
  }

  _createClass(OutputTable, [{
    key: "render",
    value: function render() {
      var headings = this.props.headings;
      var _this$props$data = this.props.data,
          _this$props$data$orde = _this$props$data.orderList,
          orderList = _this$props$data$orde === void 0 ? [] : _this$props$data$orde,
          _this$props$data$layo = _this$props$data.layoutList,
          layoutList = _this$props$data$layo === void 0 ? [] : _this$props$data$layo,
          _this$props$data$glas = _this$props$data.glasElementList,
          glasElementList = _this$props$data$glas === void 0 ? [] : _this$props$data$glas,
          _this$props$data$door = _this$props$data.doorWidthList,
          doorWidthList = _this$props$data$door === void 0 ? [] : _this$props$data$door;
      var orderListHeadings = [{
        label: headings.orderList.articleName,
        className: 'title',
        key: 'articleName',
        checkIsTitle: 'isTitle',
        ignoreInnerHeading: true
      }, {
        label: headings.orderList.articleNumber,
        className: 'article-number',
        key: 'articleNumber',
        checkIsTitle: 'isTitle'
      }, {
        label: headings.orderList.quantity,
        className: 'amount',
        key: 'quantity',
        checkIsTitle: 'isTitle'
      }];
      var renderOrderListBody = renderTableBody(orderListHeadings, this.props);
      var layoutListHeadings = [{
        label: headings.layoutList.articleName,
        className: 'title',
        key: 'articleName',
        checkIsTitle: 'isTitle',
        ignoreInnerHeading: true
      }, {
        label: headings.layoutList.articleNumber,
        className: 'article-number',
        key: 'articleNumber',
        checkIsTitle: 'isTitle'
      }, {
        label: headings.layoutList.quantity,
        className: 'amount',
        key: 'quantity',
        checkIsTitle: 'isTitle'
      }, {
        label: headings.layoutList.length,
        className: 'length',
        key: 'length',
        checkIsTitle: 'isTitle'
      }];
      var renderLayoutListBody = renderTableBody(layoutListHeadings, this.props);
      var glasElementListHeadings = [{
        label: headings.glasElementList.articleName,
        className: 'title',
        key: 'articleName',
        ignoreInnerHeading: true
      }, {
        label: headings.glasElementList.quantity,
        className: 'amount',
        key: 'quantity'
      }, {
        label: headings.glasElementList.height,
        className: 'height',
        key: 'height'
      }, {
        label: headings.glasElementList.width,
        className: 'width',
        key: 'width'
      }];
      var renderGlasElementListBody = renderTableBody(glasElementListHeadings, this.props);
      var doorWidthElementListHeadings = [{
        label: headings.doorWidthList.articleName,
        className: 'title',
        key: 'articleName',
        ignoreInnerHeading: true
      }, {
        label: headings.doorWidthList.width,
        className: 'width',
        key: 'width'
      }];
      var renderDoorWidthElementListBody = renderTableBody(doorWidthElementListHeadings, this.props);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-output-table'
      }, orderList.length > 0 && /*#__PURE__*/_react.default.createElement("table", {
        className: 'table table--order-list'
      }, renderTableHeading(orderListHeadings, this.props), renderOrderListBody(orderList)), layoutList.length > 0 && /*#__PURE__*/_react.default.createElement("table", {
        className: 'table table--layout-list'
      }, renderTableHeading(layoutListHeadings, this.props), renderLayoutListBody(layoutList)), glasElementList.length > 0 && /*#__PURE__*/_react.default.createElement("table", {
        className: 'table table--glasElements'
      }, renderTableHeading(glasElementListHeadings, this.props), renderGlasElementListBody(glasElementList)), doorWidthList.length > 0 && /*#__PURE__*/_react.default.createElement("table", {
        className: 'table table--doorWidthElements'
      }, renderTableHeading(doorWidthElementListHeadings, this.props), renderDoorWidthElementListBody(doorWidthList)));
    }
  }]);

  return OutputTable;
}(_react.default.PureComponent);

OutputTable.propTypes = {
  t: _propTypes.default.func.isRequired,
  data: _propTypes.default.shape({
    orderList: _propTypes.default.arrayOf(_propTypes.default.shape({
      articleName: _propTypes.default.string,
      articleNumber: _propTypes.default.string,
      quantity: _propTypes.default.string,
      isTitle: _propTypes.default.bool
    })),
    layoutList: _propTypes.default.arrayOf(_propTypes.default.shape({
      articleName: _propTypes.default.string,
      articleNumber: _propTypes.default.string,
      quantity: _propTypes.default.string,
      length: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
      isTitle: _propTypes.default.bool
    })),
    glasElementList: _propTypes.default.arrayOf(_propTypes.default.shape({
      articleName: _propTypes.default.string,
      quantity: _propTypes.default.string,
      height: _propTypes.default.number,
      width: _propTypes.default.number
    })),
    doorWidthList: _propTypes.default.arrayOf(_propTypes.default.shape({
      articleName: _propTypes.default.string,
      width: _propTypes.default.number
    }))
  }),
  headings: _propTypes.default.shape({
    orderList: _propTypes.default.shape({
      articleName: _propTypes.default.string,
      articleNumber: _propTypes.default.string,
      quantity: _propTypes.default.string
    }).isRequired,
    layoutList: _propTypes.default.shape({
      articleName: _propTypes.default.string,
      articleNumber: _propTypes.default.string,
      quantity: _propTypes.default.string,
      length: _propTypes.default.string
    }).isRequired,
    glasElementList: _propTypes.default.shape({
      articleName: _propTypes.default.string,
      quantity: _propTypes.default.string,
      height: _propTypes.default.string,
      width: _propTypes.default.string
    }).isRequired,
    doorWidthList: _propTypes.default.shape({
      articleName: _propTypes.default.string,
      width: _propTypes.default.string
    }).isRequired
  })
};
OutputTable.defaultProps = {
  data: {
    orderList: [],
    layoutList: [],
    glasElementList: [],
    doorWidthList: []
  },
  headings: {
    layoutList: {},
    orderList: {},
    glasElementList: {},
    doorWidthList: {}
  }
};

var _default = (0, _translate.default)(OutputTable);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/ouput-table/index.js
// module id = 556
// module chunks = 0